var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    enableBackground: "new 0 0 100 100",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m73.2743225 57.9976082c10.4652634 6.2633095 15.9852982 10.9904747 23.0909576 18.5322533-.3865128 2.4676514-1.2090836 4.8956833-2.4181061 7.1948166-2.5865707 4.8858261-6.9272842 9.1670151-12.6157837 11.8627014-1.7442168.8324356-3.518196 1.4567871-5.301979 1.9126205-15.3213234-1.6450806-32.6940842-10.2769012-47.2622223-24.8450394-16.0744552-16.0744552-24.9144144-35.5581741-25.132472-51.949768 0 0 0-.0198402.0099199-.0297604.4459751-1.2784042.9910285-2.5568104 1.6352217-3.8154354 2.9136267-5.6290359 7.3930359-9.8507671 12.4274778-12.2490406 2.2892742-1.1000877 4.7073879-1.8136597 7.14534-2.1109562 7.2840385 7.3633966 11.8130455 13.0419111 17.7096786 23.7153702-4.4893913 6.2533302-8.6615829 10.6039581-13.785244 14.7167549 3.7658958 6.1245499 8.4733429 12.1004219 14.0429192 17.6699982 4.8659248 4.8659248 10.0391273 9.0679359 15.3609467 12.5662956 4.2614135-4.9353638 8.7210388-8.9193192 15.0933456-13.1708107z",
    fill: "#fd8d14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.6e2451b4e5cb8fbd63fef8a7d0d88047.svg";
export { ForwardRef as ReactComponent };